import React from 'react';

import styles from './FondGris.module.scss';

const FontGris = () => <span className={[styles.FondGris].join(' ')} />;

export default FontGris;
